import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fetchDefault } from './Utils.js';
import { useHistory } from "react-router-dom";

import Highcharts from 'highcharts/highcharts-gantt';

const useStyles = makeStyles(theme => ({
    container: {
        width: 2180,
    },
}));

export default function SeatChart(props) {
    const classes = useStyles();
    let history = useHistory();

    useEffect(() => {


        Highcharts.setOptions({
            global: {
                useUTC: false
            }
        });

        fetchDefault('/Seat/GetChartTableList',
            (category) => {

                fetchDefault('/Seat/GetAllSeatUseInfoChart',
                    (data) => {

                        Highcharts.ganttChart('container', {

                            xAxis: [{
                                tickInterval: 60 * 60 * 1000,
                            }],

                            yAxis: {
                                type: 'category',
                                categories: category,
                            },

                            tooltip: {
                                pointFormat: '<span>{point.name}</span>'
                            },

                            series: [{
                                name: '',
                                data: data
                            }]
                        });

                    }
                );

            }
        );


        return () => {
            
        }
    }, []);

    return (
        <div>
            <div id="container" className={classes.container}></div>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/SeatChart.js